import React from 'react';
import { Settings, Users, ClipboardCheck, Video, Brain, Heart } from 'lucide-react';
import { jobOpeningPages } from '../../../../utils/types/JobOpenings';

interface TabIconConfig {
  icon: React.ReactNode;
  activeIcon: React.ReactNode;
}

const TAB_ICON_MAP: Record<string, (isActive: boolean) => React.ReactNode> = {
  'Job Opening Details': (isActive) => <Settings size={16} strokeWidth={isActive ? 2.5 : 2} />,
  'Applicant Analysis': (isActive) => <Users size={16} strokeWidth={isActive ? 2.5 : 2} />,
  'Auto-Assessments': (isActive) => <ClipboardCheck size={16} strokeWidth={isActive ? 2.5 : 2} />,
  'Smart Interviews': (isActive) => <Video size={16} strokeWidth={isActive ? 2.5 : 2} />,
  'Psychometric': (isActive) => <Brain size={16} strokeWidth={isActive ? 2.5 : 2} />,
  'Wellness': (isActive) => <Heart size={16} strokeWidth={isActive ? 2.5 : 2} />,
};

export const getTabIcon = (label: jobOpeningPages, isActive: boolean): React.ReactNode => {
  const iconFn = TAB_ICON_MAP[label];
  return iconFn ? iconFn(isActive) : null;
};
